import { render, staticRenderFns } from "./Agree21BatchArchiveResultDialog.vue?vue&type=template&id=3710bb2a&"
import script from "./Agree21BatchArchiveResultDialog.vue?vue&type=script&lang=js&"
export * from "./Agree21BatchArchiveResultDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QSpace,QBtn,QIcon,QList,QItem,QItemSection,QSeparator,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QSpace,QBtn,QIcon,QList,QItem,QItemSection,QSeparator,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
